<template>
  <section :class="{ 'border-t border-white border-solid pt-4 lg:pt-6': colorTheme === 'violet' }">
    <div v-if="title || subtitle" class="mb-4 lg:mb-6">
      <h3
        v-if="title"
        class="text-2xl md:text-3xl font-semibold leading-tight"
        :class="{ 'mb-1': subtitle, 'text-white xl:text-4xl': colorTheme === 'violet', 'text-app-primary-1-red--torch': colorTheme !== 'violet' }"
      >
        {{ title }}
      </h3>
      <p v-if="subtitle" class="hidden sm:block">
        {{ subtitle }}
      </p>
    </div>
    <ul class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-8">
      <li v-for="(entry, index) in entries" :key="index" class="flex">
        <MoleculeCardCover
          v-if="colorTheme === 'violet' && entry.title"
          :key="'card_' + index"
          :title="entry.title"
          :subtitle="entry.subtitle"
          :image="entry.image"
          :url="entry.url"
          :icon-left="entry.isPreludiumContent ? 'app-preludium' : ''"
          :icon-right="get(entry, 'icon.slug')"
          size="small"
          :theme="colorTheme"
        />
        <MoleculeCardOverview v-else-if="entry.title" :key="'card_' + index" :title="entry.title" :subtitle="entry.subtitle" :image="entry.image" :url="entry.url" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import get from 'lodash/get'

defineProps({
  title: { type: String, required: false, default: undefined },
  subtitle: { type: String, required: false, default: undefined },
  entries: { type: Array as PropType<any[]>, required: true },
  colorTheme: { type: String, required: false, default: undefined },
})
</script>
